import { urlToArray } from '../../../shared/utils';

const priceString = price => `less than $${price.slice(0, -1)}000`;

const formatPrices = regex => (item, i, arr) => {
  if (regex.test(item)) {
    [item, arr[i+1]] = [priceString(arr[i+1]), ''];
  }
  return item;
};

const splitUrl = url => {
  const { urlArray, inInd } = urlToArray(url);

  return inInd >= 0 ?
    urlArray.slice(0, inInd) : urlArray;
};

const filterKeywords = regex => word => !regex.test(word);

const parseSearchText = url => splitUrl(url)
    .map(formatPrices(/^under$/))
    .filter(filterKeywords(/^(cars|with|all|filters|)$/))
    .join(' ');

const searchTextFromUrl = url => parseSearchText(url);

export default searchTextFromUrl;
